var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21,32H3a3.027,3.027,0,0,1-3-3.047V13.714a3.027,3.027,0,0,1,3-3.047H4.5V7.62A7.569,7.569,0,0,1,12,0a7.569,7.569,0,0,1,7.5,7.62v3.047H21a3.027,3.027,0,0,1,3,3.047V28.953A3.027,3.027,0,0,1,21,32ZM3,13.714V28.953H21V13.714ZM12,3.047A4.542,4.542,0,0,0,7.5,7.62v3.047h9V7.62A4.542,4.542,0,0,0,12,3.047Zm0,21.334a3.048,3.048,0,1,1,3-3.047A3.027,3.027,0,0,1,12,24.382Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.7550e482f107d3c82773ba1b8778d241.svg";
export { ForwardRef as ReactComponent };